<template>
  <section class="platform-target">
    <div class="container">
      <h2 class="section-title">Почему X-Global выгодно для продавцов?</h2>
      <div class="target-grid">
        <div class="target-card" v-for="(item, index) in targets" :key="index">
          <div class="icon-wrapper">
            <img :src="item.icon" alt="icon" />
          </div>
          <h3>{{ item.title }}</h3>
          <p>{{ item.description }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const targets = [
  {
    title: "Бейдж “Проверенный поставщик” - больше доверия",
    icon: require("@/assets/images/sellers-icons/badge.svg"),
  },
  {
    title: "Витрина с прайсом и карточкой компании",
    icon: require("@/assets/images/sellers-icons/price.svg"),
  },
  {
    title: "Прямые заявки от покупателей без посредников",
    icon: require("@/assets/images/sellers-icons/mail.svg"),
  },
  {
    title: "Сделки только с надежными - меньше фрода",
    icon: require("@/assets/images/sellers-icons/deals.svg"),
  },
  {
    title: "Бесплатный старт - нет оплаты за размещение",
    icon: require("@/assets/images/sellers-icons/start.svg"),
  },
  {
    title: "Чат и запросы внутри платформы",
    icon: require("@/assets/images/sellers-icons/chat.svg"),
  },
];
</script>

<style scoped lang="scss">
.platform-target {
  background: #f5f7fa;
  padding: 64px 20px;

  .container {
    max-width: 1200px;
    margin: 0 auto;
  }

  .section-title {
    font-size: 45px;
    font-weight: 700;
    text-align: start;
    margin-bottom: 64px;
    color: rgba(62, 62, 62, 1);
    max-width: 560px;

    @media (max-width: 768px) {
      font-size: 24px;
      margin-bottom: 24px;
    }
  }

  .target-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
    margin: 0 auto;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }

  .target-card {
    background: white;
    border-radius: 30px;
    padding: 24px;
    box-shadow: 0px 8px 24px 0px rgba(129, 135, 189, 0.15);
    display: flex;
    flex-direction: column;
    gap: 12px;

    h3 {
      font-size: 22px;
      font-weight: 700;
      color: rgba(62, 62, 62, 1);
      margin: 0;

      @media (max-width: 768px) {
        font-size: 18px;
      }
    }

    p {
      font-size: 14px;
      color: rgba(62, 62, 62, 0.6);
      margin: 0;
    }

    .icon-wrapper {
      width: 48px;
      height: 48px;
      background: rgba(0, 199, 130, 1);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 16px;

      @media (max-width: 768px) {
        margin-bottom: 4px;
      }

      img {
        width: 24px;
        height: 24px;
      }
    }
  }
}
</style>
